<template>
  <AwSelectMenu
    v-bind="props"
    :placeholder="props.title"
    :items="props.statusOptions"
    value-key="value"
    :search-input="props.searchInput"
    :multiple="props.multiple"
    content-class="min-w-fit"
    :model-value="props.status"
    :max-visible-items="1"
    @update:model-value="(val: string | string[]) => emit('update:status', val)"
  >
    <template #default="{ modelValue }">
      <div v-if="modelValue" class="flex items-center gap-2">
        <AwIcon v-if="props.icon" :name="props.icon" color="var(--gray-3)" />
        <div v-if="typeof modelValue === 'string'">
          {{ props.statusOptions.find((status) => status.value === modelValue)?.label }}
        </div>
        <div v-else-if="modelValue.length > 0" class="flex flex-row gap-1">
          <LazyAwBadge
            style="font-size: 10px; height: 22px"
            :is-removable="props.isRemovable"
            @remove="
              emit(
                'update:status',
                modelValue.filter((status: string) => status !== modelValue[0])
              )
            "
          >
            {{ props.statusOptions.find((status) => status.value === modelValue[0])?.label }}
          </LazyAwBadge>
          <div v-if="modelValue.length > 1">
            <LazyAwBadge style="height: 22px">
              <div style="font-size: 10px">+{{ modelValue.length - 1 }}</div>
            </LazyAwBadge>
          </div>
        </div>
        <div v-else style="color: var(--gray-3)">
          {{ props.title }}
        </div>
      </div>
      <div v-else class="flex items-center gap-2" style="color: var(--gray-3)">
        <AwIcon v-if="props.icon" :name="props.icon" />
        {{ props.title }}
      </div>
    </template>
  </AwSelectMenu>
</template>

<script setup lang="ts">
type Props = {
  title?: string;
  icon?: string;
  isRemovable?: boolean;
  searchInput?: boolean;
  multiple?: boolean;
  statusOptions: { label: string; value: string }[];
  status?: string | string[];
};

type Emits = {
  "update:status": [status: string | string[]];
};

const emit = defineEmits<Emits>();
const props = withDefaults(defineProps<Props>(), {
  title: "Statut",
  icon: undefined,
  isRemovable: false,
  searchInput: false,
  multiple: false,
  status: undefined,
});
</script>

<style scoped></style>
